var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('el-container',[_c('div',{staticClass:"wraper_img"},[_c('img',{attrs:{"src":"/static/images/erweima.jpg","alt":"customer service"}}),_vm._v(" "),_c('p',[_vm._v("扫描二维码获取客服支持")])])]),_vm._v(" "),_c('navBar',{attrs:{"idx":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5740a44c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/customer.vue
// module id = null
// module chunks = 